(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const aboutText = document.querySelector('.about-main__text');
  const tagline = document.querySelector('.about-main__tagline');
  
  if (aboutText) {
    // Create intersection observer for smooth entrance animation
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add a slight delay for more elegant timing
          setTimeout(() => {
            entry.target.classList.add('fade-in');
          }, 100);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    observer.observe(aboutText);
    
    if (tagline) {
      // Add a slightly longer delay for the tagline
      const taglineObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('fade-in');
            }, 300);
            taglineObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      
      taglineObserver.observe(tagline);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Infinite carousel slider functionality
  const carousel = document.querySelector('.announcement-carousel');
  const announcementItems = document.querySelectorAll('.announcement-item:not(.announcement-item--duplicate)');
  const allItems = document.querySelectorAll('.announcement-item');
  const leftArrow = document.querySelector('.announcement-arrow--left');
  const rightArrow = document.querySelector('.announcement-arrow--right');
  const announcementBar = document.querySelector('.announcement-bar');
  
  // Handle initial animation completion and prepare for scroll behavior
  if (announcementBar) {
    if (window.pageType !== 'index') {
      // For non-index pages, show immediately without animation delay
      announcementBar.classList.add('announcement-bar--scroll-ready');
      announcementBar.classList.remove('announcement-bar--hidden');
      announcementBar.classList.add('announcement-bar--visible');
      // Dispatch custom event to let header know announcement bar is ready for scroll behavior
      document.dispatchEvent(new CustomEvent('announcementBarReady'));
    } else {
      // For index page, use the original animation timing
      setTimeout(() => {
        announcementBar.classList.add('announcement-bar--scroll-ready');
        // Ensure announcement bar is visible after initial animation
        announcementBar.classList.remove('announcement-bar--hidden');
        announcementBar.classList.add('announcement-bar--visible');
        // Dispatch custom event to let header know announcement bar is ready for scroll behavior
        document.dispatchEvent(new CustomEvent('announcementBarReady'));
      }, 1200); // Wait for initial slide-in animation to complete
    }
  }
  
  if (carousel && announcementItems.length > 1) {
    let currentSlide = 0;
    let slideInterval;
    let isTransitioning = false;
    
    function showSlide(index, animate = true) {
      const translateX = -index * 100;
      if (animate) {
        carousel.style.transition = 'transform 0.5s ease-in-out';
      } else {
        carousel.style.transition = 'none';
      }
      carousel.style.transform = `translateX(${translateX}%)`;
    }
    
    function nextSlide() {
      if (isTransitioning) return;
      
      isTransitioning = true;
      currentSlide++;
      
      // If we've reached the duplicate slide (last in DOM)
      if (currentSlide >= allItems.length - 1) {
        // Slide to the duplicate first
        showSlide(currentSlide);
        
        // After animation completes, reset to actual first slide without animation
        setTimeout(() => {
          currentSlide = 0;
          showSlide(currentSlide, false);
          isTransitioning = false;
        }, 500); // Match the CSS transition duration
      } else {
        // Normal slide
        showSlide(currentSlide);
        setTimeout(() => {
          isTransitioning = false;
        }, 500);
      }
    }
    
    function prevSlide() {
      if (isTransitioning) return;
      
      isTransitioning = true;
      
      // If we're at the first slide, go to the last real slide
      if (currentSlide === 0) {
        currentSlide = announcementItems.length - 1;
      } else {
        currentSlide--;
      }
      
      showSlide(currentSlide);
      setTimeout(() => {
        isTransitioning = false;
      }, 500);
    }
    
    function startSlider() {
      slideInterval = setInterval(nextSlide, 4000); // Change slide every 4 seconds
    }
    
    function stopSlider() {
      clearInterval(slideInterval);
    }
    
    // Left arrow click handler
    if (leftArrow) {
      leftArrow.addEventListener('click', function() {
        if (!isTransitioning) {
          stopSlider();
          prevSlide();
          setTimeout(() => {
            if (!isTransitioning) {
              startSlider();
            }
          }, 600);
        }
      });
    }
    
    // Right arrow click handler
    if (rightArrow) {
      rightArrow.addEventListener('click', function() {
        if (!isTransitioning) {
          stopSlider();
          nextSlide();
          setTimeout(() => {
            if (!isTransitioning) {
              startSlider();
            }
          }, 600);
        }
      });
    }
    
    // Start the slider
    startSlider();
    
    // Pause on hover
    carousel.addEventListener('mouseenter', stopSlider);
    carousel.addEventListener('mouseleave', startSlider);
    
    // Initialize first slide
    showSlide(0);
    
    // Show arrows with fade-in effect after announcement bar animation completes
    const arrowDelay = window.pageType !== 'index' ? 100 : 1400; // Immediate for non-index pages
    setTimeout(() => {
      if (leftArrow) {
        leftArrow.style.display = 'block';
        leftArrow.classList.add('announcement-arrow--fade-in');
      }
      if (rightArrow) {
        rightArrow.style.display = 'block';
        rightArrow.classList.add('announcement-arrow--fade-in');
      }
    }, arrowDelay);
  } else {
    // Hide arrows if there's only one or no announcements
    if (leftArrow) leftArrow.style.display = 'none';
    if (rightArrow) rightArrow.style.display = 'none';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-points-right-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const section = document.querySelector('.bold-points-right-image');
  if (!section) return;

  const points = section.querySelectorAll('.bold-points-right-image__point');
  let currentIndex = 0;
  let intervalId;

  function animatePoints() {
    // Reset all points
    points.forEach(point => point.classList.remove('is-bold'));
    
    // Bold current point
    if (points[currentIndex]) {
      points[currentIndex].classList.add('is-bold');
    }
    
    // Move to next point
    currentIndex = (currentIndex + 1) % points.length;
  }

  function startAnimation() {
    if (points.length === 0) return;
    
    // Set initial state - first point bold
    animatePoints();
    
    // Start cycling through points
    intervalId = setInterval(animatePoints, 2000); // Change every 2 seconds
  }

  function stopAnimation() {
    if (intervalId) {
      clearInterval(intervalId);
    }
  }

  // Use Intersection Observer to start animation when section is visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        startAnimation();
      } else {
        stopAnimation();
      }
    });
  }, {
    threshold: 0.3
  });

  observer.observe(section);

  // Cleanup on page unload
  window.addEventListener('beforeunload', stopAnimation);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cartForm = document.getElementById('cart-form');
  
  // GWP Configuration
  const gwpFreeVariantId = window.cartGWPConfig ? window.cartGWPConfig.freeVariantId : null;
  
  // Add staggered animation delay to cart items
  document.querySelectorAll('.cart-item').forEach((item, index) => {
    item.style.animationDelay = `${index * 0.1}s`;
  });
  
  // Initialize GWP quantity controls
  if (gwpFreeVariantId) {
    document.querySelectorAll('[data-variant-id]').forEach(element => {
      const variantId = parseInt(element.dataset.variantId);
      if (variantId === gwpFreeVariantId && element.classList.contains('quantity-plus')) {
        element.disabled = true;
        element.classList.add('gwp-disabled');
        element.setAttribute('title', 'Cannot increase quantity of free gift');
      }
    });
  }
  
  // Handle quantity changes
  document.querySelectorAll('.quantity-btn, .quantity-input').forEach(element => {
    element.addEventListener('click', handleQuantityChange);
    element.addEventListener('change', handleQuantityChange);
  });
  
  // Remove item function
  function removeItem(key) {
    const itemElement = document.querySelector(`.cart-item[data-key="${key}"]`);
    const removeButton = itemElement ? itemElement.querySelector('.cart-item-remove') : null;
    
    // Show loading state
    if (itemElement) {
      itemElement.classList.add('removing');
      if (removeButton) {
        removeButton.disabled = true;
      }
    }
    
    // Remove item directly using the Cart API
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(cart => {
      // Always reload the page after removing an item to ensure
      // discount states and pricing are properly recalculated
      window.location.reload();
    })
    .catch(error => {
      console.error('Error removing item from cart:', error);
      // Reset loading state if there was an error
      if (itemElement) {
        itemElement.classList.remove('removing');
        if (removeButton) {
          removeButton.disabled = false;
        }
      }
    });
  }

  // Handle remove buttons
  document.querySelectorAll('.cart-item-remove').forEach(button => {
    button.addEventListener('click', function() {
      const key = this.dataset.key;
      removeItem(key);
    });
  });
  
  function handleQuantityChange(event) {
    const target = event.target;
    const key = target.dataset.key;
    const variantId = parseInt(target.dataset.variantId);
    const input = document.querySelector(`input[data-key="${key}"]`);
    const isGWPFreeProduct = gwpFreeVariantId && variantId === gwpFreeVariantId;
    
    if (target.classList.contains('quantity-plus')) {
      // Block quantity increases for GWP free products
      if (isGWPFreeProduct) {
        console.log('Quantity increase blocked for free gift product');
        return;
      }
      input.value = parseInt(input.value) + 1;
      updateCart();
    } else if (target.classList.contains('quantity-minus')) {
      const currentValue = parseInt(input.value);
      const newValue = Math.max(0, currentValue - 1);
      
      if (newValue === 0) {
        // Remove the item instead of setting quantity to 0
        removeItem(key);
      } else {
        input.value = newValue;
        updateCart();
      }
    } else if (target.classList.contains('quantity-input')) {
      // For GWP free products, prevent manual increases
      if (isGWPFreeProduct) {
        const currentValue = parseInt(input.value);
        const maxAllowed = 1;
        if (currentValue > maxAllowed) {
          input.value = maxAllowed;
          console.log('Quantity manually adjusted down for free gift product');
        }
      }
      
      // Debounce input changes
      clearTimeout(target.updateTimeout);
      target.updateTimeout = setTimeout(() => {
        updateCart();
      }, 500);
    }
  }
  
  function updateCart() {
    const formData = new FormData(cartForm);
    
    fetch('/cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(cart => {
      // Update cart totals
      updateCartTotals(cart);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }
  
  function updateCartTotals(cart) {
    const subtotalElement = document.querySelector('.cart-subtotal');
    const totalElement = document.querySelector('.cart-total');
    
    if (subtotalElement) {
      subtotalElement.textContent = formatMoney(cart.total_price);
    }
    if (totalElement) {
      totalElement.textContent = formatMoney(cart.total_price);
    }
    
    // Update line totals
    cart.items.forEach(item => {
      const itemElement = document.querySelector(`[data-key="${item.key}"]`);
      if (itemElement) {
        const lineTotalElement = itemElement.querySelector('.line-total');
        const priceDisplayElement = itemElement.querySelector('.price-display');
        
        if (lineTotalElement) {
          lineTotalElement.textContent = item.line_price === 0 ? 'FREE' : formatMoney(item.line_price);
        }
        if (priceDisplayElement) {
          if (item.price === 0) {
            priceDisplayElement.style.display = 'none';
          } else {
            priceDisplayElement.style.display = 'block';
            priceDisplayElement.textContent = `${item.quantity}x ${formatMoney(item.price)}`;
          }
        }
      }
    });
    
    // Remove items with 0 quantity
    cart.items.forEach(item => {
      if (item.quantity === 0) {
        const itemElement = document.querySelector(`[data-key="${item.key}"]`);
        if (itemElement) {
          itemElement.remove();
        }
      }
    });
    
    // If cart is empty, reload the page to show empty state
    if (cart.items.length === 0) {
      window.location.reload();
    }
  }
  
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sortSelect = document.querySelector('[data-sort-select]');
  const collectionGrid = document.querySelector('[data-collection-grid]');
  
  if (!collectionGrid) return;
  
  // Animate items on page load
  function animateItems() {
    const items = collectionGrid.querySelectorAll('[data-collection-item]');
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('animate-in');
      }, index * 100); // 100ms stagger between each item
    });
  }
  
  // Trigger animation after a short delay to ensure elements are rendered
  setTimeout(animateItems, 50);
  
  if (!sortSelect) return;
  
  sortSelect.addEventListener('change', function() {
    const sortBy = this.value;
    const items = Array.from(collectionGrid.querySelectorAll('[data-collection-item]'));
    
    // Remove animation classes before sorting
    items.forEach(item => {
      item.classList.remove('animate-in');
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
    });
    
    items.sort((a, b) => {
      if (sortBy === 'featured') {
        const aIndex = parseInt(a.dataset.sortFeatured);
        const bIndex = parseInt(b.dataset.sortFeatured);
        return aIndex - bIndex;
      } else if (sortBy === 'best-selling') {
        const aId = parseInt(a.dataset.sortBestSelling);
        const bId = parseInt(b.dataset.sortBestSelling);
        return bId - aId; // Reverse order for "best selling"
      } else if (sortBy === 'price-ascending') {
        const aPrice = parseInt(a.dataset.sortPrice);
        const bPrice = parseInt(b.dataset.sortPrice);
        return aPrice - bPrice;
      } else if (sortBy === 'price-descending') {
        const aPrice = parseInt(a.dataset.sortPrice);
        const bPrice = parseInt(b.dataset.sortPrice);
        return bPrice - aPrice;
      } else if (sortBy === 'alphabetical') {
        const aTitle = a.dataset.sortTitle.toLowerCase();
        const bTitle = b.dataset.sortTitle.toLowerCase();
        return aTitle.localeCompare(bTitle);
      }
      return 0;
    });
    
    // Clear the grid and re-append sorted items
    collectionGrid.innerHTML = '';
    items.forEach(item => collectionGrid.appendChild(item));
    
    // Re-animate after sorting
    setTimeout(animateItems, 50);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const toggles = document.querySelectorAll('.footer__nav-toggle');
    
    toggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.parentElement.querySelector('.footer__nav-content');
        
        // Close all other accordions
        toggles.forEach(otherToggle => {
          if (otherToggle !== this) {
            otherToggle.setAttribute('aria-expanded', 'false');
            otherToggle.parentElement.classList.remove('active');
          }
        });
        
        // Toggle current accordion
        this.setAttribute('aria-expanded', !isExpanded);
        this.parentElement.classList.toggle('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const body = document.body;
  const header = document.querySelector('.header');
  const announcementBar = document.querySelector('.announcement-bar');

  // Header and announcement bar scroll behavior
  let lastScrollTop = 0;
  let isScrolling = false;
  let scrollThreshold = 100; // Minimum scroll distance before hiding header
  let scrollEnabled = false; // Only enable after announcement bar animation completes

  function handleScroll() {
    // Don't handle scroll until announcement bar animation is complete
    if (!scrollEnabled) return;
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const searchOverlay = document.getElementById('searchOverlay');
    
    // Don't hide header/announcement if we're near the top
    if (scrollTop < scrollThreshold) {
      header.classList.remove('header--hidden');
      
      // If we're still in the initial loading or scroll-ready state, maintain that
      if (header.classList.contains('header--loading')) {
        // Do nothing, let the initial animation complete
      } else if (header.classList.contains('header--scroll-ready')) {
        // Keep the scroll-ready state without animation
        header.classList.add('header--scroll-ready');
      } else {
        // Otherwise add the visible class for bounce animation
        header.classList.add('header--visible');
      }
      
      if (announcementBar) {
        announcementBar.classList.remove('announcement-bar--hidden');
        announcementBar.classList.add('announcement-bar--visible');
      }
      return;
    }

    // Determine scroll direction
    if (scrollTop > lastScrollTop && scrollTop > scrollThreshold) {
      // Scrolling down - hide header and announcement bar
      header.classList.add('header--hidden');
      header.classList.remove('header--visible');
      header.classList.remove('header--scroll-ready'); // Remove scroll-ready to ensure proper transitions
      if (announcementBar) {
        announcementBar.classList.add('announcement-bar--hidden');
        announcementBar.classList.remove('announcement-bar--visible');
      }
      
      // Close search overlay when scrolling down
      if (searchOverlay && searchOverlay.classList.contains('active')) {
        searchOverlay.classList.remove('active');
        const searchInput = document.getElementById('search-input');
        if (searchInput) {
          searchInput.blur();
        }
      }
    } else if (scrollTop < lastScrollTop) {
      // Scrolling up - show header and announcement bar with bounce
      header.classList.remove('header--hidden');
      
      // Always apply the bounce animation when scrolling up after scrolling down
      header.classList.remove('header--scroll-ready');
      header.classList.add('header--visible');
      
      if (announcementBar) {
        announcementBar.classList.remove('announcement-bar--hidden');
        announcementBar.classList.add('announcement-bar--visible');
      }
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  }

  // Throttle scroll events for better performance
  function throttleScroll() {
    if (!isScrolling) {
      window.requestAnimationFrame(handleScroll);
      isScrolling = true;
      setTimeout(() => {
        isScrolling = false;
      }, 16); // ~60fps
    }
  }

  // Handle scroll enablement based on page type
  if (window.headerPageType !== 'index') {
    // For non-index pages, enable scroll immediately and ensure header is visible
    scrollEnabled = true;
    if (header) {
      header.classList.remove('header--hidden');
      header.classList.add('header--visible');
    }
  } else {
    // For index page, listen for announcement bar ready event
    document.addEventListener('announcementBarReady', function() {
      scrollEnabled = true;
    });
  }
  
  // If no announcement bar exists, always enable scroll (fallback)
  if (!announcementBar) {
    scrollEnabled = true;
  }

  // Listen for scroll events
  window.addEventListener('scroll', throttleScroll);

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      hamburger.classList.toggle('active');
      mobileMenu.classList.toggle('active');
      body.classList.toggle('mobile-menu-open');
    });

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(event) {
      if (!hamburger.contains(event.target) && !mobileMenu.contains(event.target)) {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        body.classList.remove('mobile-menu-open');
      }
    });

    // Close mobile menu when clicking on links
    const mobileLinks = document.querySelectorAll('.mobile-nav-link');
    mobileLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        hamburger.classList.remove('active');
        mobileMenu.classList.remove('active');
        body.classList.remove('mobile-menu-open');
      });
    });
  }

  // Email Popup functionality
  const emailPopupOverlay = document.getElementById('emailPopupOverlay');
  const emailPopupClose = document.getElementById('emailPopupClose');
  const emailPopupForm = document.getElementById('emailPopupForm');
  
  // Testing variable - set to true to show modal immediately for testing
  const isTestingModal = false; // Change to true for testing
  
  // Check if popup should be shown
  function shouldShowPopup() {
    if (isTestingModal) return true; // Always show in testing mode
    const popupShown = sessionStorage.getItem('emailPopupShown');
    return !popupShown;
  }
  
  // Show popup
  function showEmailPopup() {
    if (emailPopupOverlay) {
      emailPopupOverlay.classList.add('active');
      body.style.overflow = 'hidden';
      // Only mark popup as shown if not in testing mode
      if (!isTestingModal) {
        sessionStorage.setItem('emailPopupShown', 'true');
      }
    }
  }
  
  // Hide popup
  function hideEmailPopup() {
    if (emailPopupOverlay) {
      emailPopupOverlay.classList.remove('active');
      body.style.overflow = '';
    }
  }
  
  // Initialize popup timer - only if popup is enabled
  const popupEnabled = emailPopupOverlay ? emailPopupOverlay.dataset.popupEnabled === 'true' : false;
  if (popupEnabled && shouldShowPopup()) {
    if (isTestingModal) {
      // Show immediately in testing mode
      showEmailPopup();
    } else {
      // Normal delay
      setTimeout(function() {
        showEmailPopup();
      }, 5000); // Show after 5 seconds
    }
  }
  
  // Close popup event listeners
  if (emailPopupClose) {
    emailPopupClose.addEventListener('click', hideEmailPopup);
  }
  
  // Close popup when clicking overlay
  if (emailPopupOverlay) {
    emailPopupOverlay.addEventListener('click', function(event) {
      if (event.target === emailPopupOverlay) {
        hideEmailPopup();
      }
    });
  }
  
  // Handle form submission success (called by Klaviyo module)
  window.addEventListener('klaviyo:success', function() {
    setTimeout(() => {
      hideEmailPopup();
    }, 10000)
  });
  
  // Close popup on Escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && emailPopupOverlay && emailPopupOverlay.classList.contains('active')) {
      hideEmailPopup();
    }
  });

  // Update cart count dynamically (if needed)
  function updateCartCount() {
    fetch('/cart.json')
      .then(response => response.json())
      .then(data => {
        const cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = data.item_count;
        }
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);

  // Search functionality
  const searchToggles = document.querySelectorAll('.search-toggle');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchClose = document.getElementById('searchClose');
  const searchInput = document.getElementById('search-input');

  // Show search overlay
  function showSearch() {
    if (searchOverlay) {
      searchOverlay.classList.add('active');
      // Focus on input after animation
      setTimeout(() => {
        if (searchInput) {
          searchInput.focus();
        }
      }, 300);
    }
  }

  // Hide search overlay
  function hideSearch() {
    if (searchOverlay) {
      searchOverlay.classList.remove('active');
      if (searchInput) {
        searchInput.blur();
      }
    }
  }

  // Search toggle event listeners
  searchToggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      // Toggle search overlay - if active, hide it; if not, show it
      if (searchOverlay && searchOverlay.classList.contains('active')) {
        hideSearch();
      } else {
        showSearch();
      }
    });
  });

  // Close search event listener
  if (searchClose) {
    searchClose.addEventListener('click', hideSearch);
  }

  // Close search on escape key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('active')) {
      hideSearch();
    }
  });

  // Close search when clicking outside
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function(event) {
      if (event.target === searchOverlay) {
        hideSearch();
      }
    });
  }

  // If on the index page, convert loading state to visible after the slide-in animation
  if (window.headerPageType === 'index' && header) {
    setTimeout(() => {
      header.classList.remove('header--loading');
      header.classList.add('header--scroll-ready');
      // Don't add header--visible here to avoid double animation
    }, 1200); // Match the headerSlideIn duration
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const passwordInput = document.getElementById('Password');
    const passwordToggle = document.getElementById('password-toggle');

    if (passwordInput && passwordToggle) {
      passwordToggle.addEventListener('click', function () {
        const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password';
        passwordInput.setAttribute('type', type);
        this.textContent = type === 'password' ? 'Show' : 'Hide';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchGrid = document.querySelector('[data-search-grid]');
  
  if (!searchGrid) return;
  
  // Animate items on page load
  function animateItems() {
    const items = searchGrid.querySelectorAll('[data-search-item]');
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('animate-in');
      }, index * 100); // 100ms stagger between each item
    });
  }
  
  // Trigger animation after a short delay to ensure elements are rendered
  setTimeout(animateItems, 50);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-5-point-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Check if animation is enabled
  const sectionElement = document.querySelector('.pdp-5-points');
  if (!sectionElement) return;
  
  const animationEnabled = sectionElement.getAttribute('data-enable-animation') === 'true';
  
  if (!animationEnabled) return;
  
  const textElements = document.querySelectorAll('.pdp-5-points__text');
  
  if (textElements.length === 0) return;
  
  let currentIndex = 0;
  
  function highlightNextText() {
    // Remove highlight from all text elements
    textElements.forEach(text => {
      text.classList.remove('pdp-5-points__text--highlighted');
    });
    
    // Add highlight to current text element
    textElements[currentIndex].classList.add('pdp-5-points__text--highlighted');
    
    // Move to next index, cycle back to 0 when reaching the end
    currentIndex = (currentIndex + 1) % textElements.length;
  }
  
  // Start the animation immediately
  highlightNextText();
  
  // Continue the cycle every 4 seconds
  setInterval(highlightNextText, 4000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-variant-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const swiperElement = document.querySelector('.variant-carousel__swiper');
  if (!swiperElement) return;
  
  // Initialize Swiper
  const swiper = new Swiper('.variant-carousel__swiper', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: false,
    centeredSlides: false,
    loop: true, // Enable infinite loop
    
    breakpoints: {
      // Mobile (default)
      0: {
        slidesPerView: 1.3, // Shows current slide + 30% of next slide
        spaceBetween: 5,
        centeredSlides: false,
      },
      // 768px and up (tablet/desktop)
      768: {
        slidesPerView: 4,
        spaceBetween: 8,
        centeredSlides: false,
      }
    },
    
    // Callback when Swiper is initialized
    on: {
      init: function() {
        // Remove loading class to show the carousel
        swiperElement.classList.remove('variant-carousel__swiper--loading');
      }
    }
  });
  
  // Prevent default drag behavior on images
  swiperElement.addEventListener('dragstart', function(e) {
    e.preventDefault();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const productPage = document.querySelector('.product-page');
  if (!productPage) return;
  
  // Wait for SwiperJS to be available (since it's loaded from theme.liquid)
  function initializeWhenSwiperReady() {
    if (typeof Swiper !== 'undefined') {
      initProductPage();
    } else {
      setTimeout(initializeWhenSwiperReady, 100);
    }
  }
  
  function initProductPage() {
  
  // Optimized SwiperJS Gallery management system
  class VariantImageGallery {
    constructor() {
      this.productData = window.productData;
      this.variantImageMap = new Map();
      this.commonImages = [];
      this.commonLastImages = [];
      this.currentVariantHandle = this.productData.selectedVariantHandle;
      
      // Swiper instances
      this.mainSwiper = null;
      this.thumbsSwiper = null;
      
      // Containers
      this.mainSwiperWrapper = document.getElementById('main-swiper-wrapper');
      this.thumbnailsSwiperWrapper = document.getElementById('thumbnails-swiper-wrapper');
      
      this.init();
    }
    
    init() {
      // Build image mappings for variant switching (but skip initial render)
      this.buildImageMappings();
      // Initialize swiper with pre-rendered HTML
      this.initializeSwiper();
      this.bindEvents();
    }
    
    buildImageMappings() {
      // Only build mappings for variant switching - initial HTML is already rendered
      this.productData.images.forEach(imageData => {
        if (!imageData || typeof imageData !== 'object') return;
        
        const imageUrl = imageData.src;
        const altText = imageData.alt || '';
        
        if (!imageUrl || typeof imageUrl !== 'string') return;
        
        const filename = this.extractFilenameFromUrl(imageUrl);
        const lowercaseFilename = filename.toLowerCase();
        const lowercaseAlt = altText.toLowerCase();
        
        const imageObj = {
          src: imageUrl,
          alt: altText
        };
        
        if (lowercaseAlt.includes('common-image-last')) {
          this.commonLastImages.push({
            ...imageObj,
            isCommon: true,
            isLast: true
          });
        }
        else if (lowercaseFilename.startsWith('common-image')) {
          const position = this.extractCommonImagePosition(lowercaseFilename);
          this.commonImages.push({
            ...imageObj,
            position: position,
            isCommon: true
          });
        } else {
          this.productData.variants.forEach(variant => {
            if (lowercaseFilename.startsWith(variant.handle + '-')) {
              if (!this.variantImageMap.has(variant.handle)) {
                this.variantImageMap.set(variant.handle, []);
              }
              this.variantImageMap.get(variant.handle).push({
                ...imageObj,
                isCommon: false
              });
            }
          });
        }
      });
      
      this.commonImages.sort((a, b) => a.position - b.position);
    }
    
    extractFilenameFromUrl(url) {
      if (!url || typeof url !== 'string') return '';
      const urlParts = url.split('/');
      const filenameWithParams = urlParts[urlParts.length - 1];
      const filename = filenameWithParams.split('?')[0];
      return filename.replace(/\.[^/.]+$/, '');
    }
    
    extractCommonImagePosition(filename) {
      const match = filename.match(/common-image-(\d+)/);
      return match ? parseInt(match[1]) : 999;
    }
    
    getImagesForVariant(variantHandle) {
      const variantImages = this.variantImageMap.get(variantHandle) || [];
      const combinedImages = [];
      
      const sortedCommonImages = [...this.commonImages].sort((a, b) => a.position - b.position);
      
      sortedCommonImages.forEach(commonImage => {
        combinedImages.push(commonImage);
      });
      
      variantImages.forEach(variantImage => {
        combinedImages.push(variantImage);
      });
      
      this.commonLastImages.forEach(lastImage => {
        combinedImages.push(lastImage);
      });
      
      return combinedImages;
    }
    
    renderGalleryForVariant(variantHandle) {
      // Only re-render when switching variants, not on initial load
      const images = this.getImagesForVariant(variantHandle);
      
      // Clear existing slides
      this.mainSwiperWrapper.innerHTML = '';
      this.thumbnailsSwiperWrapper.innerHTML = '';
      
      // Generate slides
      images.forEach((image) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = `<img src="${image.src}" alt="${image.alt || ''}" loading="eager" width="600" height="600">`;
        this.mainSwiperWrapper.appendChild(slide);
        
        const thumbSlide = document.createElement('div');
        thumbSlide.className = 'swiper-slide';
        thumbSlide.innerHTML = `<img src="${image.src}" alt="${image.alt || ''}" loading="eager" width="120" height="120">`;
        this.thumbnailsSwiperWrapper.appendChild(thumbSlide);
      });
      
      // Re-initialize swiper with new slides
      this.initializeSwiper();
    }
    
    initializeSwiper() {
      const isMobile = window.innerWidth < 768;
      
      // Destroy existing swipers
      if (this.mainSwiper) {
        this.mainSwiper.destroy(true, true);
      }
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy(true, true);
      }
      
      if (isMobile) {
        this.mainSwiper = new Swiper('.main-image-swiper', {
          loop: true,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
            draggable: true,
          },
        });
      } else {
        this.thumbsSwiper = new Swiper('.thumbnails-swiper', {
          loop: false,
          spaceBetween: 3,
          slidesPerView: 5,
          direction: 'vertical',
          freeMode: true,
          watchSlidesProgress: true,
        });
        
        this.mainSwiper = new Swiper('.main-image-swiper', {
          loop: true,
          spaceBetween: 0,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          thumbs: {
            swiper: this.thumbsSwiper,
          },
        });
        
        this.addThumbnailAutoScroll();
      }
    }
    
    addThumbnailAutoScroll() {
      if (!this.thumbsSwiper) return;
      
      const thumbnailSlides = this.thumbsSwiper.slides;
      
      thumbnailSlides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          const activeIndex = this.thumbsSwiper.activeIndex;
          const slidesPerView = this.thumbsSwiper.params.slidesPerView;
          const lastVisibleIndex = activeIndex + slidesPerView - 1;
          
          if (index === lastVisibleIndex && index < thumbnailSlides.length - 1) {
            this.thumbsSwiper.slideNext();
          }
          else if (index === activeIndex && activeIndex > 0) {
            this.thumbsSwiper.slidePrev();
          }
        });
      });
    }
    
    switchToVariant(variantHandle) {
      if (this.currentVariantHandle === variantHandle) return;
      
      this.currentVariantHandle = variantHandle;
      // Only re-render if switching to a different variant
      this.renderGalleryForVariant(variantHandle);
    }
    
    bindEvents() {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          if (this.mainSwiper) {
            this.initializeSwiper();
          }
        }, 250);
      });
    }
  }
  
  // Initialize the gallery - now much faster since HTML is pre-rendered
  const imageGallery = new VariantImageGallery();
  
  // Dynamic Variant Carousel Management - Completely rebuilt
  class VariantCarousel {
    constructor() {
      this.productData = window.productData;
      this.currentVariantId = this.productData.selectedVariantId;
      this.carouselSection = document.getElementById('variant-carousel-section');
      this.carouselWrapper = document.getElementById('variant-carousel-wrapper');
      this.swiperElement = document.querySelector('.variant-carousel__swiper');
      this.overlay = document.querySelector('.variant-carousel__overlay');
      this.swiper = null;
      
      // Only initialize if we have the necessary elements and multiple variants
      if (this.carouselWrapper && this.productData.variants.length > 1) {
        this.init();
      }
    }
    
    init() {
      this.renderInitialCarousel();
    }
    
    renderInitialCarousel() {
      // Show overlay during initial render
      this.showOverlay();
      
      // Clear the wrapper
      this.carouselWrapper.innerHTML = '';
      
      // Get all variants except the current one
      const otherVariants = this.productData.variants.filter(variant => 
        variant.id !== this.currentVariantId
      );
      
      
      // Create slides for each variant
      otherVariants.forEach(variant => {
        const slide = this.createVariantSlide(variant);
        this.carouselWrapper.appendChild(slide);
      });
      
      // Initialize Swiper after adding slides
      setTimeout(() => {
        this.initializeSwiper();
      }, 0);
    }
    
    createVariantSlide(variant) {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide variant-carousel__slide';
      slide.setAttribute('data-variant-id', variant.id);
      
      // Find variant image
      let variantImageSrc = '';
      
      // Try to find variant-specific image by matching handle in filename
      const variantHandle = variant.handle;
      const variantImage = this.productData.images.find(image => {
        const filename = this.extractFilenameFromUrl(image.src).toLowerCase();
        return filename.includes(variantHandle);
      });
      
      if (variantImage) {
        variantImageSrc = variantImage.src;
      } else if (this.productData.images.length > 0) {
        // Fallback to first product image
        variantImageSrc = this.productData.images[0].src;
      }
      
      // Create slide HTML
      slide.innerHTML = `
        <div class="variant-carousel__link" data-variant-id="${variant.id}">
          <div class="variant-carousel__image-container">
            <img 
              src="${variantImageSrc}"
              alt="${variant.title}"
              class="variant-carousel__image"
              width="400"
              height="400"
              loading="lazy"
            >
          </div>
          
          <div class="variant-carousel__content">
            <h3 class="variant-carousel__variant-title">${variant.title}</h3>
            <p class="variant-carousel__product-name">${this.productData.productTitle || ''}</p>
            <p class="variant-carousel__product-type">${this.productData.productType || ''}</p>
          </div>
        </div>
      `;
      
      // Add click handler
      const link = slide.querySelector('.variant-carousel__link');
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleVariantClick(variant.id);
      });
      
      return slide;
    }
    
    extractFilenameFromUrl(url) {
      if (!url || typeof url !== 'string') return '';
      const urlParts = url.split('/');
      const filenameWithParams = urlParts[urlParts.length - 1];
      const filename = filenameWithParams.split('?')[0];
      return filename.replace(/\.[^/.]+$/, '');
    }
    
    handleVariantClick(variantId) {
      // Use the existing selectVariant function
      if (typeof selectVariant === 'function') {
        selectVariant(variantId);
      }
    }
    
    showOverlay() {
      if (this.overlay) {
        this.overlay.classList.add('active');
      }
      if (this.swiperElement) {
        this.swiperElement.classList.add('updating');
      }
    }
    
    hideOverlay() {
      if (this.overlay) {
        this.overlay.classList.remove('active');
      }
      if (this.swiperElement) {
        this.swiperElement.classList.remove('updating');
      }
    }
    
    initializeSwiper() {
      if (!this.swiperElement) return;
      
      // Destroy existing swiper if it exists
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      
      // Initialize new swiper
      this.swiper = new Swiper('.variant-carousel__swiper', {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: false,
        centeredSlides: false,
        loop: this.carouselWrapper.children.length > 4,
        
        breakpoints: {
          // Mobile (default)
          0: {
            slidesPerView: 1.3,
            spaceBetween: 5,
            centeredSlides: false,
          },
          // 768px and up (tablet/desktop)
          768: {
            slidesPerView: 4,
            spaceBetween: 8,
            centeredSlides: false,
          }
        },
        
        // Callback when Swiper is initialized
        on: {
          init: () => {
            // Remove loading class to show the carousel
            this.swiperElement.classList.remove('variant-carousel__swiper--loading');
            this.hideOverlay();
          }
        }
      });
      
      // Prevent default drag behavior on images
      this.swiperElement.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });
    }
    
    updateCarousel(newVariantId) {
      if (this.currentVariantId === newVariantId) return;
      
      // Show overlay during update
      this.showOverlay();
      
      // Store the new variant ID
      const oldVariantId = this.currentVariantId;
      this.currentVariantId = newVariantId;
      
      // Completely rebuild the carousel
      // This is more reliable than trying to manipulate existing slides
      this.carouselWrapper.innerHTML = '';
      
      // Get all variants except the current one
      const otherVariants = this.productData.variants.filter(variant => 
        variant.id !== newVariantId
      );
      
      // Create slides for each variant
      otherVariants.forEach(variant => {
        const slide = this.createVariantSlide(variant);
        this.carouselWrapper.appendChild(slide);
      });
      
      // Re-initialize swiper
      setTimeout(() => {
        this.initializeSwiper();
      }, 10);
    }
  }
  
  // Initialize the variant carousel
  const variantCarousel = new VariantCarousel();
  
  // Variant Selection Logic
  const variantSwatches = document.querySelectorAll('.variant-swatch');
  const variantSelector = document.querySelector('.variant-selector');
  const selectedVariantSpan = document.querySelector('.selected-variant');
  const selectedSwatchName = document.querySelector('.selected-swatch-name');
  const addToCartBtn = document.querySelector('.add-to-cart-btn');
  const btnPrice = document.querySelector('.btn-price');
  
  // Helper function to update URL with variant ID
  function updateVariantURL(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.pushState({ variantId: variantId }, '', url);
  }
  
  // Helper function to find variant data by ID
  function findVariantById(variantId) {
    return window.productData.variants.find(variant => variant.id == variantId);
  }
  
  // Helper function to decode HTML entities
  function decodeHtmlEntities(text) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  }
  
  // Helper function to update cart button based on variant availability
  function updateCartButton(variant) {
    if (!addToCartBtn || !variant) return;
    
    const btnText = addToCartBtn.querySelector('.btn-text');
    
    if (variant.available) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('disabled');
      if (btnText) {
        btnText.textContent = 'ADD TO CART';
      }
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
      if (btnText) {
        btnText.textContent = 'SOLD OUT';
      }
    }
  }
  
  // Helper function to update "What's in it" accordion content
  function updateWhatsInItContent(variant) {
    const whatsInItContent = document.getElementById('whats-in-it-content');
    if (!whatsInItContent || !variant) return;
    
    if (variant.shade_ingredients_copy_html && variant.shade_ingredients_copy_html !== 'null') {
      // Use the pre-rendered HTML from Liquid's metafield_tag
      whatsInItContent.innerHTML = variant.shade_ingredients_copy_html;
    } else {
      // If no ingredients copy available, hide or show fallback content
      whatsInItContent.innerHTML = '<p>Ingredient list coming soon!</p>';
    }
  }
  
  // Function to select a variant by ID and update all UI elements
  function selectVariant(variantId) {
    const variant = findVariantById(variantId);
    if (!variant) return false;
    
    // Find the corresponding swatch
    const targetSwatch = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!targetSwatch) return false;
    
    const variantTitle = variant.title;
    const variantPrice = variant.price;
    const variantHandle = variant.handle;
    const swatchName = variant.swatch_name;
    
    // Update active swatch
    variantSwatches.forEach(s => s.classList.remove('active'));
    targetSwatch.classList.add('active');
    
    // Update selected variant
    if (selectedVariantSpan) {
      const decodedTitle = decodeHtmlEntities(variantTitle);
      selectedVariantSpan.textContent = decodedTitle.toUpperCase();
    }
    
    // Update selected swatch name
    if (selectedSwatchName && swatchName) {
      const decodedSwatchName = decodeHtmlEntities(swatchName);
      selectedSwatchName.textContent = decodedSwatchName;
    }
    
    // Update hidden select
    if (variantSelector) {
      variantSelector.value = variantId;
    }
    
    // Update price
    if (btnPrice) {
      const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(variantPrice / 100);
      
      const cleanPrice = formattedPrice.replace(/\.00$/, '');
      btnPrice.textContent = cleanPrice;
    }
    
    // Update cart button availability
    updateCartButton(variant);
    
    // Update URL
    updateVariantURL(variantId);
    
    // Switch gallery images for this variant
    imageGallery.switchToVariant(variantHandle);
    
    // Update variant carousel to exclude the newly selected variant
    if (variantCarousel) {
      variantCarousel.updateCarousel(variantId);
    }
    
    // Update "What's in it" accordion content with variant-specific data
    updateWhatsInItContent(variant);
    
    return true;
  }
  
  // Check URL for variant parameter and load that variant on page load
  function initializeVariantFromURL() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromURL = urlParams.get('variant');
    
    if (variantIdFromURL) {
      // Try to select the variant from URL (even if out of stock)
      const variant = findVariantById(parseInt(variantIdFromURL));
      if (variant) {
        selectVariant(parseInt(variantIdFromURL));
        return; // Successfully loaded variant from URL
      }
    }
    
    // If no URL variant or variant not found, default to first available variant
    const firstAvailableVariant = window.productData.variants.find(variant => variant.available);
    if (firstAvailableVariant) {
      selectVariant(firstAvailableVariant.id);
    } else {
      // If no available variants, select the selected variant from Shopify (even if out of stock)
      selectVariant(window.productData.selectedVariantId);
    }
  }
  
  // Initialize variant selection from URL
  initializeVariantFromURL();
  
  variantSwatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      const variantId = parseInt(this.dataset.variantId);
      selectVariant(variantId);
    });
  });
  
  // Quantity Controls
  const quantityInput = document.querySelector('.quantity-input');
  const quantityMinus = document.querySelector('.quantity-minus');
  const quantityPlus = document.querySelector('.quantity-plus');
  
  if (quantityMinus && quantityInput) {
    quantityMinus.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  }
  
  if (quantityPlus && quantityInput) {
    quantityPlus.addEventListener('click', function() {
      const currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });
  }
  
  // Accordion Functionality
  const accordionHeaders = document.querySelectorAll('.accordion-header');
  
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const accordion = this.closest('.accordion');
      const isOpen = accordion.classList.contains('open');
      
      // Close all accordions
      document.querySelectorAll('.accordion').forEach(acc => {
        acc.classList.remove('open');
      });
      
      // Toggle current accordion
      if (!isOpen) {
        accordion.classList.add('open');
      }
    });
  });
  
  // Cart API Helper Class
  // Form submission handling with GWP
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const addToCartBtn = productForm.querySelector('.add-to-cart-btn');
      const btnText = addToCartBtn.querySelector('.btn-text');
      const quantityInput = productForm.querySelector('.quantity-input');
      const variantSelector = productForm.querySelector('.variant-selector');
      
      // Get form data
      const quantity = parseInt(quantityInput.value) || 1;
      const variantId = parseInt(variantSelector.value);
      
      // Disable button and show loading state
      addToCartBtn.disabled = true;
      const originalText = btnText.textContent;
      btnText.textContent = 'ADDING...';
      
      try {
        // Prepare items array
        const items = [{
          id: variantId,
          quantity: quantity
        }];

        // Declare shared variables for both product-based and price-only GWP checks
        let currentCart = null;
        let currentCartTotal = 0;
        let projectedCartTotal = 0;

        // Check for GWP campaigns
        console.log('[GWP] Checking for GWP campaigns...', {
          exists: !!window.productData.gwpCampaigns,
          isArray: Array.isArray(window.productData.gwpCampaigns),
          length: window.productData.gwpCampaigns?.length,
          campaigns: window.productData.gwpCampaigns
        });

        if (window.productData.gwpCampaigns && Array.isArray(window.productData.gwpCampaigns) && window.productData.gwpCampaigns.length > 0) {
          console.log('[GWP] GWP campaigns found, checking cart...');
          try {
            // Get current cart to check total and existing items
            currentCart = await CartAPI.getCart();
            currentCartTotal = currentCart.total_price; // in cents
            console.log('[GWP] Current cart total:', currentCartTotal / 100, 'USD');

            // Get selected variant price to calculate projected cart total
            const selectedVariant = window.productData.variants.find(v => v.id === variantId);
            const variantPrice = selectedVariant ? selectedVariant.price : 0;
            projectedCartTotal = currentCartTotal + (variantPrice * quantity);
            console.log('[GWP] Projected cart total:', projectedCartTotal / 100, 'USD');

            // Check each GWP campaign
            console.log('[GWP] Checking', window.productData.gwpCampaigns.length, 'campaigns...');
            for (const campaign of window.productData.gwpCampaigns) {
              console.log('[GWP] Campaign #' + campaign.campaignId + ':', campaign);

              // Validate campaign data
              if (!campaign.freeVariantId || typeof campaign.freeVariantId !== 'number' || campaign.freeVariantId <= 0) {
                console.warn(`[GWP] Campaign #${campaign.campaignId}: Invalid free variant ID`);
                continue;
              }

              // Check if required product exists in cart OR is being added right now
              const requiredProductInCart = currentCart.items.find(item =>
                item.product_id === campaign.requiredProductId
              );
              const requiredProductBeingAdded = campaign.requiredProductId === window.productData.productId;
              const requiredProductExists = requiredProductInCart || requiredProductBeingAdded;

              console.log(`[GWP] Campaign #${campaign.campaignId} - Required Product Check:`, {
                requiredProductId: campaign.requiredProductId,
                currentProductId: window.productData.productId,
                inCart: !!requiredProductInCart,
                beingAdded: requiredProductBeingAdded,
                exists: requiredProductExists,
                cartItemIds: currentCart.items.map(item => item.product_id)
              });

              // Check if required product exists (in cart or being added)
              if (requiredProductExists) {
                console.log(`GWP Campaign #${campaign.campaignId}: Required product found ${requiredProductBeingAdded ? '(being added now)' : '(already in cart)'}`);

                // Check if minimum price requirement is met using projected cart total
                if (projectedCartTotal >= campaign.minimumPriceCents) {
                  // Check if free product is already in cart
                  const freeProductInCart = currentCart.items.find(item =>
                    item.variant_id === campaign.freeVariantId
                  );

                  // Only add free product if it's not already in cart
                  if (!freeProductInCart) {
                    items.push({
                      id: campaign.freeVariantId,
                      quantity: 1, // Always add only 1 free item
                      properties: {
                        gift: true,
                        gwp_campaign_id: campaign.campaignId,
                        gwp_required_product_id: campaign.requiredProductId
                      }
                    });
                    console.log(`GWP Campaign #${campaign.campaignId}: Adding free gift - ${campaign.freeProductTitle}`);
                  } else {
                    console.log(`GWP Campaign #${campaign.campaignId}: Free product already in cart, skipping`);
                  }
                } else {
                  console.log(`GWP Campaign #${campaign.campaignId}: Projected cart total ($${projectedCartTotal / 100}) does not meet minimum ($${campaign.minimumPriceCents / 100})`);
                }
              } else {
                console.log(`GWP Campaign #${campaign.campaignId}: Required product not found in cart`);
              }
            }
          } catch (cartError) {
            console.warn('GWP: Failed to check cart for GWP eligibility', cartError);
            // Continue without adding free products if cart check fails
          }
        }

        // Check for price-only GWP campaigns
        console.log('[GWP Price-Only] Checking for price-only GWP campaigns...', {
          exists: !!window.productData.gwpPriceOnlyCampaigns,
          isArray: Array.isArray(window.productData.gwpPriceOnlyCampaigns),
          length: window.productData.gwpPriceOnlyCampaigns?.length,
          campaigns: window.productData.gwpPriceOnlyCampaigns
        });

        if (window.productData.gwpPriceOnlyCampaigns && Array.isArray(window.productData.gwpPriceOnlyCampaigns) && window.productData.gwpPriceOnlyCampaigns.length > 0) {
          console.log('[GWP Price-Only] Price-only campaigns found, checking cart...');
          try {
            // Get current cart if not already fetched (in case product-based campaigns didn't run)
            if (!currentCart) {
              currentCart = await CartAPI.getCart();
              currentCartTotal = currentCart.total_price;
              const selectedVariant = window.productData.variants.find(v => v.id === variantId);
              const variantPrice = selectedVariant ? selectedVariant.price : 0;
              projectedCartTotal = currentCartTotal + (variantPrice * quantity);
            }

            console.log('[GWP Price-Only] Using cart total:', currentCartTotal / 100, 'USD, Projected total:', projectedCartTotal / 100, 'USD');
            console.log('[GWP Price-Only] Checking', window.productData.gwpPriceOnlyCampaigns.length, 'price-only campaigns...');
            for (const campaign of window.productData.gwpPriceOnlyCampaigns) {
              console.log('[GWP Price-Only] Campaign #' + campaign.campaignId + ':', campaign);

              // Validate campaign data
              if (!campaign.freeVariantId || typeof campaign.freeVariantId !== 'number' || campaign.freeVariantId <= 0) {
                console.warn(`[GWP Price-Only] Campaign #${campaign.campaignId}: Invalid free variant ID`);
                continue;
              }

              if (!campaign.minimumPriceCents || campaign.minimumPriceCents <= 0) {
                console.warn(`[GWP Price-Only] Campaign #${campaign.campaignId}: Invalid minimum price`);
                continue;
              }

              // Check if minimum price requirement is met using projected cart total
              if (projectedCartTotal >= campaign.minimumPriceCents) {
                console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Price threshold met ($${projectedCartTotal / 100} >= $${campaign.minimumPriceCents / 100})`);

                // Check if free product is already in cart
                const freeProductInCart = currentCart.items.find(item =>
                  item.variant_id === campaign.freeVariantId
                );

                // Only add free product if it's not already in cart
                if (!freeProductInCart) {
                  items.push({
                    id: campaign.freeVariantId,
                    quantity: 1,
                    properties: {
                      gift: true,
                      gwp_price_only_campaign_id: campaign.campaignId,
                      gwp_type: 'price_only'
                    }
                  });
                  console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Adding free gift - ${campaign.freeProductTitle}`);
                } else {
                  console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Free product already in cart, skipping`);
                }
              } else {
                console.log(`[GWP Price-Only] Campaign #${campaign.campaignId}: Projected cart total ($${projectedCartTotal / 100}) does not meet minimum ($${campaign.minimumPriceCents / 100})`);
              }
            }
          } catch (cartError) {
            console.warn('[GWP Price-Only] Failed to check cart for price-only GWP eligibility', cartError);
            // Continue without adding free products if cart check fails
          }
        }

        // Debug: Log items array before adding to cart
        console.log('[GWP] Items to be added to cart:', items);

        // Add items to cart
        console.log('[GWP] Calling CartAPI.addItems...');
        const result = await CartAPI.addItems(items);
        console.log('[GWP] CartAPI.addItems result:', result);


        document.dispatchEvent(new CustomEvent('cart:add', {
          bubbles: true,
          detail: { cart: result }
        }));


      } catch (error) {
        console.error('[GWP] Failed to add to cart:', error);
      } finally {
        // Re-enable button
        addToCartBtn.disabled = false;
        btnText.textContent = originalText;
      }
    });
  }

  // Related Products Carousel Initialization
  const relatedProductsCarouselElement = document.querySelector('.related-products-carousel__swiper');
  if (relatedProductsCarouselElement) {
    const relatedProductsSwiper = new Swiper('.related-products-carousel__swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: false,
      centeredSlides: false,
      loop: true,
      navigation: {
        nextEl: '.related-products-carousel__arrow--next',
        prevEl: '.related-products-carousel__arrow--prev',
      },

      breakpoints: {
        // Mobile (default)
        0: {
          slidesPerView: 1.3,
          spaceBetween: 5,
          centeredSlides: false,
        },
        // 768px and up (tablet/desktop)
        768: {
          slidesPerView: 4,
          spaceBetween: 8,
          centeredSlides: false,
        }
      }
    });
  }

  } // End of initProductPage function
  
  // Start initialization when Swiper is ready
  initializeWhenSwiperReady();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweet-spot-variants"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sortSelect = document.querySelector('[data-sort-select]');
  const variantsGrid = document.querySelector('[data-variants-grid]');
  
  if (!variantsGrid) return;
  
  // Animate items on page load
  function animateItems() {
    const items = variantsGrid.querySelectorAll('[data-variant-item]');
    items.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('animate-in');
      }, index * 100); // 100ms stagger between each item
    });
  }
  
  // Trigger animation after a short delay to ensure elements are rendered
  setTimeout(animateItems, 50);
  
  if (!sortSelect) return;
  
  sortSelect.addEventListener('change', function() {
    const sortBy = this.value;
    const items = Array.from(variantsGrid.querySelectorAll('[data-variant-item]'));
    
    // Remove animation classes before sorting
    items.forEach(item => {
      item.classList.remove('animate-in');
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
    });
    
    items.sort((a, b) => {
      if (sortBy === 'featured') {
        const aIndex = parseInt(a.dataset.sortFeatured);
        const bIndex = parseInt(b.dataset.sortFeatured);
        return aIndex - bIndex;
      } else if (sortBy === 'best-selling') {
        // For best-selling, we'll use variant ID as a placeholder
        // In a real implementation, you'd want to sort by actual sales data
        const aId = parseInt(a.dataset.sortBestSelling);
        const bId = parseInt(b.dataset.sortBestSelling);
        return bId - aId; // Reverse order for "best selling"
      }
      return 0;
    });
    
    // Clear the grid and re-append sorted items
    variantsGrid.innerHTML = '';
    items.forEach(item => variantsGrid.appendChild(item));
    
    // Re-animate after sorting
    setTimeout(animateItems, 50);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-image-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.variant-image-carousel');
  
  carousels.forEach(function(carousel) {
    const swiperContainer = carousel.querySelector('.variant-image-carousel__swiper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    
    if (slides.length <= 1) {
      // Hide arrows if there's only one slide
      const prevArrow = carousel.querySelector('.variant-image-carousel__arrow--prev');
      const nextArrow = carousel.querySelector('.variant-image-carousel__arrow--next');
      if (prevArrow) prevArrow.style.display = 'none';
      if (nextArrow) nextArrow.style.display = 'none';
      return;
    }
    
         // Initialize Swiper
     const swiper = new Swiper(swiperContainer, {
       slidesPerView: 1.15, // Show main slide + peek of next slide on mobile
       spaceBetween: 0,
       loop: true,
       centeredSlides: false,
       navigation: {
         nextEl: carousel.querySelector('.variant-image-carousel__arrow--next'),
         prevEl: carousel.querySelector('.variant-image-carousel__arrow--prev'),
       },
       breakpoints: {
         768: {
           slidesPerView: 3,
           spaceBetween: 0,
           centeredSlides: false,
         }
       },
      on: {
        init: function() {
          updateBorderRadius(this);
        },
        slideChange: function() {
          updateBorderRadius(this);
        },
        resize: function() {
          updateBorderRadius(this);
        }
      }
    });
    
    function updateBorderRadius(swiperInstance) {
      const isDesktop = window.innerWidth >= 768;
      const slides = swiperInstance.slides;
      
      // Reset all border radius
      slides.forEach(slide => {
        const slideContent = slide.querySelector('.variant-image-carousel__slide');
        if (slideContent) {
          slideContent.style.borderTopLeftRadius = '';
          slideContent.style.borderBottomLeftRadius = '';
          slideContent.style.borderTopRightRadius = '';
          slideContent.style.borderBottomRightRadius = '';
        }
      });
      
      if (isDesktop) {
        // Desktop: Get current active index and calculate visible slides
        const activeIndex = swiperInstance.activeIndex;
        const slidesPerView = 3;
        
        // Get the first visible slide (leftmost)
        const firstVisibleIndex = activeIndex;
        const firstSlide = slides[firstVisibleIndex];
        if (firstSlide) {
          const slideContent = firstSlide.querySelector('.variant-image-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopLeftRadius = '6px';
            slideContent.style.borderBottomLeftRadius = '6px';
          }
        }
        
        // Get the third visible slide (rightmost)
        const thirdVisibleIndex = (activeIndex + 2) % slides.length;
        const thirdSlide = slides[thirdVisibleIndex];
        if (thirdSlide) {
          const slideContent = thirdSlide.querySelector('.variant-image-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopRightRadius = '6px';
            slideContent.style.borderBottomRightRadius = '6px';
          }
        }
      } else {
        // Mobile: Apply border radius to active slide only (left side since it peeks)
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (activeSlide) {
          const slideContent = activeSlide.querySelector('.variant-image-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopLeftRadius = '6px';
            slideContent.style.borderBottomLeftRadius = '6px';
          }
        }
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-video-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.variant-video-carousel');

  carousels.forEach(function(carousel) {
    const swiperContainer = carousel.querySelector('.variant-video-carousel__swiper');
    const slides = swiperContainer.querySelectorAll('.swiper-slide');

    // Force all play buttons to be visible immediately
    function forcePlayButtonVisibility() {
      requestAnimationFrame(function() {
        const allPlayButtons = carousel.querySelectorAll('.variant-video-carousel__play-button');
        allPlayButtons.forEach(function(btn) {
          const slide = btn.closest('.variant-video-carousel__slide');
          // Only force visibility if video is not playing
          if (!slide || !slide.classList.contains('is-playing')) {
            btn.style.display = 'block';
            btn.style.opacity = '1';
            btn.style.visibility = 'visible';
          }
        });
      });
    }

    // Run immediately
    //forcePlayButtonVisibility();

    // Also run after a short delay to catch any Swiper clones
    // setTimeout(forcePlayButtonVisibility, 100);

    if (slides.length <= 1) {
      // Hide arrows if there's only one slide
      const prevArrow = carousel.querySelector('.variant-video-carousel__arrow--prev');
      const nextArrow = carousel.querySelector('.variant-video-carousel__arrow--next');
      if (prevArrow) prevArrow.style.display = 'none';
      if (nextArrow) nextArrow.style.display = 'none';
      return;
    }

    // Initialize Swiper
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1, // Show only 1 video on mobile
      spaceBetween: 8,
      loop: true,
      centeredSlides: false,
      navigation: {
        nextEl: carousel.querySelector('.variant-video-carousel__arrow--next'),
        prevEl: carousel.querySelector('.variant-video-carousel__arrow--prev'),
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
        }
      },
      on: {
        init: function() {
          // updateBorderRadius(this);
          // forcePlayButtonVisibility();
        },
        slideChange: function() {
          // updateBorderRadius(this);
          pauseAllVideos(carousel);
          // forcePlayButtonVisibility();
        },
        slideChangeTransitionEnd: function() {
          // forcePlayButtonVisibility();
        },
        resize: function() {
          // updateBorderRadius(this);
          // forcePlayButtonVisibility();
        }
      }
    });

    function updateBorderRadius(swiperInstance) {
      const isDesktop = window.innerWidth >= 768;
      const slides = swiperInstance.slides;

      // Reset all border radius
      slides.forEach(slide => {
        const slideContent = slide.querySelector('.variant-video-carousel__slide');
        if (slideContent) {
          slideContent.style.borderTopLeftRadius = '';
          slideContent.style.borderBottomLeftRadius = '';
          slideContent.style.borderTopRightRadius = '';
          slideContent.style.borderBottomRightRadius = '';
        }
      });

      if (isDesktop) {
        // Desktop: Get current active index and calculate visible slides
        const activeIndex = swiperInstance.activeIndex;

        // Get the first visible slide (leftmost)
        const firstSlide = slides[activeIndex];
        if (firstSlide) {
          const slideContent = firstSlide.querySelector('.variant-video-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopLeftRadius = '6px';
            slideContent.style.borderBottomLeftRadius = '6px';
          }
        }

        // Get the third visible slide (rightmost)
        const thirdVisibleIndex = (activeIndex + 2) % slides.length;
        const thirdSlide = slides[thirdVisibleIndex];
        if (thirdSlide) {
          const slideContent = thirdSlide.querySelector('.variant-video-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopRightRadius = '6px';
            slideContent.style.borderBottomRightRadius = '6px';
          }
        }
      } else {
        // Mobile: Apply border radius to active slide only (left side since it peeks)
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (activeSlide) {
          const slideContent = activeSlide.querySelector('.variant-video-carousel__slide');
          if (slideContent) {
            slideContent.style.borderTopLeftRadius = '6px';
            slideContent.style.borderBottomLeftRadius = '6px';
            slideContent.style.borderTopRightRadius = '6px';
            slideContent.style.borderBottomRightRadius = '6px';
          }
        }
      }
    }

    // Video play/pause functionality
    function pauseAllVideos(carouselElement) {
      const allVideos = carouselElement.querySelectorAll('.variant-video-carousel__video');
      allVideos.forEach(function(video) {
        video.pause();
        video.currentTime = 0;
        const slide = video.closest('.variant-video-carousel__slide');
        if (slide) {
          slide.classList.remove('is-playing');
        }
      });
    }

    // Handle video clicks
    carousel.addEventListener('click', function(e) {
      const videoContainer = e.target.closest('.variant-video-carousel__video-container');
      if (!videoContainer) return;

      // Don't interfere with link clicks on the overlay
      if (e.target.closest('.variant-video-carousel__link')) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const video = videoContainer.querySelector('.variant-video-carousel__video');
      const slide = videoContainer.closest('.variant-video-carousel__slide');

      if (!video) return;

      if (video.paused) {
        pauseAllVideos(carousel);
        video.play();
        slide.classList.add('is-playing');
      } else {
        video.pause();
        slide.classList.remove('is-playing');
      }
    });

    // Pause video when it ends
    carousel.addEventListener('ended', function(e) {
      if (e.target.classList.contains('variant-video-carousel__video')) {
        const slide = e.target.closest('.variant-video-carousel__slide');
        if (slide) {
          slide.classList.remove('is-playing');
        }
      }
    }, true);
  });
});

  } catch(e) { console.error(e); }
})();
})();
